{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://forms/psu-award",
  "title": "PSU Award",
  "description": "PSU (Performance Stock Unit) award — create and edit unified form.",
  "type": "object",
  "properties": {
    "participantId": {
      "$ref": "module://psu-award#properties/participantId",
      "required": true,
      "permissions": { "edit": "EDIT_PARTICIPANT_FIELD" },
      "disabledDisplayField": "participantName"
    },
    "id": {
      "$ref": "module://psu-award#properties/id"
    },
    "participantName": {
      "type": "string",
      "widget": "hidden"
    },
    "firstName": {
      "$ref": "module://psu-award#properties/firstName",
      "readOnly": true
    },
    "middleName": {
      "$ref": "module://psu-award#properties/middleName",
      "readOnly": true
    },
    "lastName": {
      "$ref": "module://psu-award#properties/lastName",
      "readOnly": true
    },
    "awardNumber": {
      "$ref": "module://psu-award#properties/awardNumber",
      "required": true
    },
    "grantId": {
      "$ref": "module://psu-award#properties/grantId",
      "required": true
    },
    "planId": {
      "$ref": "module://psu-award#properties/planId"
    },
    "planName": {
      "$ref": "module://psu-award#properties/planName",
      "readOnly": true
    },
    "planTypeId": {
      "$ref": "module://psu-award#properties/planTypeId"
    },
    "planType": {
      "$ref": "module://psu-award#properties/planType",
      "readOnly": true
    },
    "grantName": {
      "$ref": "module://psu-award#properties/grantName",
      "widget": "hidden"
    },
    "isOffline": {
      "$ref": "module://psu-award#properties/isOffline"
    },
    "issuedUnits": {
      "$ref": "module://psu-award#properties/issuedUnits",
      "required": true
    },
    "fmvAtGrant": {
      "$ref": "module://psu-award#properties/fmvAtGrant",
      "required": true
    },
    "grantPrice": {
      "$ref": "module://psu-award#properties/grantPrice",
      "readOnly": true
    },
    "grantValue": {
      "$ref": "module://psu-award#properties/grantValue",
      "required": true
    },
    "grantIssueDate": {
      "$ref": "module://psu-award#properties/grantIssueDate",
      "required": true
    },
    "vestingStartDate": {
      "$ref": "module://psu-award#properties/vestingStartDate",
      "required": true
    },
    "performanceRuleName": {
      "$ref": "module://psu-award#properties/performanceRuleName",
      "readOnly": true
    },
    "performanceRuleId": {
      "$ref": "module://psu-award#properties/performanceRuleId"
    },
    "vestingTemplateId": {
      "$ref": "module://psu-award#properties/vestingTemplateId"
    },
    "vestingTemplateName": {
      "$ref": "module://psu-award#properties/vestingTemplateName",
      "widget": "hidden"
    },
    "poolId": {
      "$ref": "module://psu-award#properties/poolId"
    },
    "grantReason": {
      "$ref": "module://psu-award#properties/grantReason",
      "required": true
    },
    "notes": {
      "$ref": "module://psu-award#properties/notes"
    },
    "settlementTypeId": {
      "$ref": "module://settlement#/$defs/settlementTypeId"
    },
    "isAccepted": {
      "$ref": "module://psu-award#properties/isAccepted",
      "hiddenWhen": {
        "field": "#/properties/isOffline",
        "notEquals": true
      }
    },
    "acceptanceDate": {
      "$ref": "module://psu-award#properties/acceptanceDate",
      "hiddenWhen": {
        "anyOf": [
          {
            "field": "#/properties/isOffline",
            "notEquals": true
          },
          {
            "field": "#/properties/isAccepted",
            "notEquals": true
          }
        ]
      }
    },
    "awardAcceptanceDocumentInput": {
      "$ref": "module://psu-award#properties/awardAcceptanceDocumentInput",
      "hiddenWhen": {
        "anyOf": [
          {
            "field": "#/properties/isOffline",
            "notEquals": true
          },
          {
            "field": "#/properties/isAccepted",
            "notEquals": true
          }
        ]
      }
    },
    "acceptanceDocumentId": {
      "$ref": "module://psu-award#properties/acceptanceDocumentId"
    },
    "acceptanceDocumentRemovedIds": {
      "$ref": "module://psu-award#properties/acceptanceDocumentRemovedIds"
    },
    "acceptanceDocumentName": {
      "$ref": "module://psu-award#properties/acceptanceDocumentName",
      "readOnly": true
    },
    "acceptanceMethodId": {
      "$ref": "module://psu-award#properties/acceptanceMethodId"
    },
    "acceptanceMethodName": {
      "$ref": "module://psu-award#properties/acceptanceMethodName",
      "readOnly": true
    },
    "methodType": {
      "$ref": "module://psu-award#properties/methodType"
    },
    "methodTypeId": {
      "$ref": "module://psu-award#properties/methodTypeId"
    },
    "awardAdjustmentMethodId": {
      "$ref": "module://psu-award#properties/awardAdjustmentMethodId"
    },
    "asOfDate": {
      "$ref": "module://psu-award#properties/asOfDate",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "residualDate": {
      "$ref": "module://psu-award#properties/residualDate",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "amortizationDate": {
      "$ref": "module://psu-award#properties/amortizationDate",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "cancelShareTypeId": {
      "$ref": "module://psu-award#properties/cancelShareTypeId",
      "disabledWhen": {
        "anyOf": [
          { "field": "#/properties/methodType", "isEmpty": true },
          { "field": "#/properties/asOfDate", "isEmpty": true }
        ]
      }
    },
    "targetCancelled": {
      "$ref": "module://psu-award#properties/targetCancelled",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "adjustmentReason": {
      "$ref": "module://psu-award#properties/adjustmentReason",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_PSU_AWARD",
      "successMessage": "PSU Award saved successfully",
      "refreshEntities": [
        "PSU Award"
      ]
    }
  },
  "modes": {
    "create": {
      "type": "array",
      "items": {
        "$ref": "#"
      },
      "minItems": 1,
      "maxItems": 25,
      "dataSource": {
        "submit": {
          "actionId": "SAVE_PSU_AWARD",
          "successMessage": "PSU Award(s) created successfully",
          "refreshEntities": [
            "PSU Award"
          ],
          "constants": {
            "importType": "add"
          }
        }
      },
      "lifecycle": {
        "submitBehavior": "reset"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_PSU_AWARD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "actionId": "SAVE_PSU_AWARD",
          "successMessage": "PSU Award updated successfully",
          "refreshEntities": [
            "PSU Award"
          ],
          "constants": {
            "importType": "edit"
          },
          "invalidateActions": [
            "FETCH_PSU_AWARD"
          ]
        }
      },
      "lifecycle": {
        "dirtyGuard": true,
        "submitBehavior": "close",
        "serverErrors": "inline"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_PSU_AWARD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
